import { render } from "./integrations.vue?vue&type=template&id=43dafdc2&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"

import "./integrations.vue?vue&type=style&index=0&id=43dafdc2&lang=css"
import "./integrations.vue?vue&type=style&index=1&id=43dafdc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dafdc2"]])

export default __exports__